<template>
  <section class="container-main">
    <Header :open-menu-modal="openMenuModal" />
    <div class="container-inner">
      <div class="banner">
        <div class="banner-title">
          <h3 class="fade-in-text do-hyeon-regular" :class="{ visible: isVisible }">
            AXIS Gallery
          </h3>
        </div>
      </div>
      <section class="container gallery">
        <div class="gallery-inner">
          <div class="title-box" ref="galleryTitleBox">
            <h3>
              <span style="color: #00c5e3; font-weight: 700">AXIS</span> 갤러리<br>

            </h3>
            <p>
              주안에서 함께하는,<br>
              하나되는 순간들
            </p>
          </div>
          <div class="gallery-box">
            <!-- ❗중요: 이 부분에서 pagedGalleryList 를 넘겨야 합니다 -->
            <GalleryList
                :gallery-list="galleryData"
                :select-gallery="selectGallery"
            />
<!--            <gallery-list :gallery-list="galleryData" :select-gallery="selectGallery" />-->
<!--            <GalleryList :gallery-list="galleryList" :select-gallery="selectGallery" />-->
          </div>

          <!-- ✅ Pagination 컴포넌트 추가 -->
          <Pagination
              :page="paginationInfo"
              @update-page="handlePageUpdate"
          />
        </div>
      </section>
    </div>
    <Footer />
    <GalleryImageModal v-if="galleryImageView && selectedGallery" :selected-gallery="selectedGallery" :close-btn="closeImageModalBtn" />
    <MenuModal v-if="menuModalView" :close-menu-modal="closeMenuModal" />

  </section>
</template>
<script>
import Header from "@/components/core/Header.vue";
import GalleryList from "@/views/gallery/components/GalleryList.vue";
import Footer from "@/components/core/Footer.vue";
import GalleryImageModal from "@/views/modal/GalleryImageModal.vue";
import MenuModal from "@/views/modal/MenuModal.vue";
import {fetchBoardData, fetchBoardOne} from "@/services/api/boardApi";
import Pagination from "@/components/common/pagination.vue";

export default {
  name: "Gallery",
  components: {Pagination, MenuModal, GalleryImageModal, Footer, GalleryList, Header},
  data() {
    return {
      init: false,
      isVisible: false,
      galleryImageView: false,
      selectedGallery: null,
      menuModalView: false,
      itemsPerPage: 8, // 한 번에 보여줄 항목 수
      currentPage: 1,   // 현재 페이지
      totalPages: 1,
      galleryData: [],

    }
  },

  computed: {
    /** ✅ 페이지네이션에 전달할 정보 */
    paginationInfo() {
      return {
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        totalElements: this.totalElements,
        size: this.itemsPerPage,
        last: this.currentPage === this.totalPages,
        next: this.currentPage < this.totalPages
      };
    }
  },

  created() {
    this.init = true;
  },

  mounted() {
    // 컴포넌트가 마운트된 후에 애니메이션을 트리거
    this.loadGalleryData();
    this.showText();

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -150px 0px',  // 뷰포트 하단에서 200px 지나야만 트리거
      threshold: 0.2  // 요소의 30%가 보일 때 트리거
    };


    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 요소가 보이면 isVisible을 true로 설정
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    observer.observe(this.$refs.galleryTitleBox);

  },

  methods: {

    handlePageUpdate(newPage) {
      this.currentPage = newPage;
      this.loadGalleryData(); // ✅ 페이지 바뀔 때마다 다시 불러옴
      // window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    async loadGalleryData() {
      try {
        const response = await fetchBoardData(
            ['GALLERY'],
            this.currentPage - 1,
            this.itemsPerPage,
            'created_at,DESC'
        );

        this.galleryData = response.data; // ✅ 실제 데이터만 저장
        const pageInfo = response.page;
        this.totalElements = pageInfo.totalElements;
        this.totalPages = pageInfo.totalPages;
      } catch (err) {
        console.error('갤러리 데이터 로드 실패:', err);
      }
    },

    async loadGalleryOne(id) {
      try {
        return await fetchBoardOne(id);
      } catch (err) {
        console.log(err)
      }
    },

    showText() {
      setTimeout(() => {
        this.isVisible = true;
      }, 100)
    },

    // selectGallery(gallery) {
    //   this.galleryImageView = true;
    //   this.selectedGallery = gallery;
    // },

    async selectGallery(id) {
      this.selectedGallery = await this.loadGalleryOne(id);
      this.galleryImageView = true;
    },


    closeImageModalBtn() {
      this.galleryImageView = false;
    },

    openMenuModal() {
      this.menuModalView = true;
    },

    closeMenuModal() {
      this.menuModalView = false;
    },

  }
}
</script>

<style scoped lang="scss">
.container-main {
  .container-inner {

    .banner {

      display: flex;
      justify-content: center; /* 수평 가운데 정렬 */
      align-items: center; /* 수직 가운데 정렬 */

      position: relative;
      width: 100%;
      height: 520px;
      overflow: hidden;

      background-repeat: no-repeat;
      background-size: 2560px;
      background-position: center center;
      //background-image: url("../../assets/resized/20240901_142152.jpg");
      background-image: url("../../assets/background/KakaoTalk_20250215_204430329_01.jpg");
      background-attachment: fixed;
      //background-position-y: -542px;
      background-position-y: bottom;
      background-color: rgba(0, 0, 0, 0.5);
      background-blend-mode: color;


      .banner-title {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 9;
        text-align: center;
        color: #fff;
        width: 1280px;
        box-sizing: border-box;
        margin: 0 auto;
        line-height: 1.4;
        padding-top: 86px;
        flex-direction: column;

        h3 {
          font-weight: 700;
          font-size: 36px;

          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -8px; /* 밑줄과 텍스트 사이의 여백 추가 */
            height: 3px; /* 밑줄 두께 */
            background-color: #fff; /* 밑줄 색상 */
            width: 100%; /* 호버 시 밑줄의 너비가 100%로 확장 */
          }
        }

        p {
          margin-top: 20px;
          font-weight: 200;
        }

      }

    }

    .gallery {

      box-sizing: border-box;
      padding-top: 30px;
      padding-bottom: 160px;

      .gallery-inner {

        .title-box {
          max-width: 1280px;
          width: 100%;
          margin: 0 auto;
          box-sizing: border-box;
          padding-top: 100px;
          padding-left: 10px;
          padding-right: 10px;
          text-align: left;

          transform: translateX(50px);
          transition: all .3s ease-out;

          &.visible {
            transform: translateX(0);
          }

          h3 {
            font-size: 28px;
            color: #000;
            font-weight: 300;
          }

          p {
            line-height: 1.3;
            font-size: 22px;
            margin-top: 15px;
            color: #555;
            font-weight: 300;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1512px) {
  .container-main .container-inner .gallery .gallery-inner .title-box {
    box-sizing: border-box;
    padding-left: 25px;
    padding-right: 25px;
  }

  .container-main .container-inner .gallery .gallery-inner .gallery-box {
    box-sizing: border-box;
    padding: 15px;
  }
}

@media screen and (max-width: 768px) {

  .container-main {
    overflow: hidden;
  }

  .container-main .container-inner .banner {
    background-position-y: center;
    background-size: cover;
  }

  .container-main .container-inner .banner .banner-title h3 {
    font-size: 30px;
  }

  .container-main .container-inner .gallery {
    padding-bottom: 40px;
  }

  .container-main .container-inner .gallery .gallery-inner .gallery-box {
    padding-top: 20px;
  }

  .container-main .container-inner .gallery .gallery-inner .title-box {
    padding-top: 40px;
  }

  .container-main .container-inner .gallery .gallery-inner .title-box p {
    font-size: 20px;
  }

  .container-main .container-inner .gallery .gallery-inner .title-box h3 {
    font-size: 24px;
  }



}
</style>